import { render } from "./UserContentComponent.vue?vue&type=template&id=38704c22"
import script from "./UserContentComponent.vue?vue&type=script&lang=js"
export * from "./UserContentComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__